import { Button, Space, Text } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSkatConnection } from '@features/vatDeclarations/contexts/skatConnectionContext'
import { IntegrationFormFlow } from '@features/vatDeclarations/enums/integrationFormFlow'
import { SkatIntegrationStatus } from '@features/vatDeclarations/enums/skatIntegrationStatus'

import { useSegment } from '../../../../../../hooks'
import { Steps } from '../Steps'

interface InstructionsPageProps {
  handleCancelClick: () => void
}

export const InstructionsPage = ({ handleCancelClick }: InstructionsPageProps) => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { updateSkatConnection, connectionState, setConnectionState } = useSkatConnection()

  const isLoading =
    connectionState === SkatIntegrationStatus.Redirecting || connectionState === SkatIntegrationStatus.Connecting

  const handleDisconnectClick = useCallback(() => {
    track('xxx - Bookkeeping - DK VAT integration', {
      flow: IntegrationFormFlow.Disconnect,
      step: '1 - How to',
      buttonClick: 'Start disconnecting',
    })
    setConnectionState(SkatIntegrationStatus.Redirecting)
    setTimeout(() => {
      setConnectionState(SkatIntegrationStatus.Connecting)
      updateSkatConnection(IntegrationFormFlow.Disconnect)
    }, 1000)
  }, [updateSkatConnection, setConnectionState, track])

  const buttonCopy = {
    [SkatIntegrationStatus.Connecting]: t('skat_form.disconnecting'),
    [SkatIntegrationStatus.Redirecting]: t('skat_form.redirecting'),
    [SkatIntegrationStatus.Idle]: t('skat_form.disconnect.start_disconnecting'),
  }

  return (
    <>
      <Text variant="h1">{t('skat_form.disconnect.instructions.header')}</Text>
      <Space size="s8" />
      <Text>{t('skat_form.disconnect.instructions.description')}</Text>
      <Space size="s24" />
      <Steps />
      <Space size="s24" />
      <Button icon="squareArrowOutUpRight" fullWidth onClick={handleDisconnectClick} loading={isLoading}>
        {buttonCopy[connectionState]}
      </Button>
      <Space size="s8" />
      <Button variant="text" fullWidth onClick={handleCancelClick}>
        {t('cancel')}
      </Button>
    </>
  )
}
